import { useMutation, useQuery } from '@tanstack/react-query';

import { TextToPayCompletePaymentRequest } from '@m/types/api';
import { heapAddEventProperties } from '@m/utils/heap';
import { PaymentService } from 'apps/pay/services';

export const visitDetailsQueryKey = (visitCode: string) => ['userVisitDetails', visitCode];

export function useVisitDetails(
  visitCode: string,
  { refetchInterval = false }: { refetchInterval?: number | false } = {},
) {
  return useQuery({
    queryKey: visitDetailsQueryKey(visitCode),
    refetchInterval,
    queryFn: async () => {
      const response = await PaymentService.getVisitDetails({ visitCode });
      if (response) {
        heapAddEventProperties({
          transactionId: response.id,
          siteId: response.site?.id,
          siteName: response.site?.name,
        });
      }
      return response;
    },
  });
}

export function useCompletePayment() {
  return useMutation({
    mutationFn: (params: TextToPayCompletePaymentRequest & { visitCode: string }) =>
      PaymentService.completePayment(params),
  });
}

export function useBeginPayment() {
  return useMutation({
    mutationFn: ({ visitCode }: { visitCode: string }) =>
      PaymentService.beginPayment({ visitCode }),
  });
}

export function useWrongVehicle() {
  return useMutation({
    mutationFn: ({ visitCode }: { visitCode: string }) =>
      PaymentService.wrongVehicle({ visitCode }),
  });
}
